import { render, staticRenderFns } from "./achatWidget.vue?vue&type=template&id=4e165909&scoped=true&lang=pug&"
import script from "./achatWidget.vue?vue&type=script&lang=js&"
export * from "./achatWidget.vue?vue&type=script&lang=js&"
import style0 from "./achatWidget.vue?vue&type=style&index=0&id=4e165909&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e165909",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSkeletonLoader})
